import { createContext, type PropsWithChildren, type RefObject, useMemo, useRef } from 'react';

export type ListingPageComponentRefs = {
  actionBarRef: RefObject<HTMLDivElement>;
  agentCardCtaRef: RefObject<HTMLButtonElement>;
  contactFormCtaRef: RefObject<HTMLButtonElement>;
  contactFormInputGridRef: RefObject<HTMLFieldSetElement>;
};

export const ListingPageComponentRefsContext = createContext<ListingPageComponentRefs | undefined>(undefined);

export const ListingPageComponentRefsProvider = ({ children }: PropsWithChildren) => {
  const actionBarRef = useRef<HTMLDivElement>(null);
  const agentCardCtaRef = useRef<HTMLButtonElement>(null);
  const contactFormCtaRef = useRef<HTMLButtonElement>(null);
  const contactFormInputGridRef = useRef<HTMLFieldSetElement>(null);

  const value = useMemo(
    () => ({ actionBarRef, agentCardCtaRef, contactFormCtaRef, contactFormInputGridRef }),
    [actionBarRef, agentCardCtaRef, contactFormCtaRef, contactFormInputGridRef],
  );

  return <ListingPageComponentRefsContext.Provider value={value}>{children}</ListingPageComponentRefsContext.Provider>;
};
